(function () {
  var SCALE      = 4;
  var SVG_ASPECT = 1758.42 / 1538.085;

  var el, canvas, ctx;
  var W, H, LW, LH;
  var t         = 0;
  var raf       = null;
  var svgImg    = null;
  var svgReady  = false;
  var distField = null;

  function h2r(p, q, h) {
    if (h < 0) h += 1; if (h > 1) h -= 1;
    if (h < 1/6) return p + (q-p)*6*h;
    if (h < 1/2) return q;
    if (h < 2/3) return p + (q-p)*(2/3-h)*6;
    return p;
  }
  function hsl(h, s, l) {
    var q = l < 0.5 ? l*(1+s) : l+s-l*s, p = 2*l-q;
    return [
      Math.round(h2r(p,q,h+1/3)*255),
      Math.round(h2r(p,q,h    )*255),
      Math.round(h2r(p,q,h-1/3)*255)
    ];
  }

  function buildDF() {
    var ofc  = document.createElement('canvas');
    ofc.width = LW; ofc.height = LH;
    var oc   = ofc.getContext('2d');

    var symW = Math.min(LW, LH) * 1.5;
    var symH = symW * SVG_ASPECT;
    oc.drawImage(svgImg, (LW-symW)/2, (LH-symH)/2, symW, symH);

    var px    = oc.getImageData(0, 0, LW, LH).data;
    var sym   = new Uint8Array(LW * LH);
    var dist  = new Float32Array(LW * LH).fill(Infinity);
    var queue = [];

    for (var i = 0; i < LW * LH; i++) {
      sym[i] = px[i*4+3] > 15 ? 1 : 0;
    }

    for (var i = 0; i < LW * LH; i++) {
      if (!sym[i]) continue;
      var x = i % LW, y = (i / LW) | 0;
      if ((x > 0    && !sym[i-1])
       || (x < LW-1 && !sym[i+1])
       || (y > 0    && !sym[i-LW])
       || (y < LH-1 && !sym[i+LW])) {
        dist[i] = 0;
        queue.push(i);
      }
    }

    var head = 0;
    while (head < queue.length) {
      var cur = queue[head++];
      var x = cur % LW, y = (cur / LW) | 0;
      var nd = dist[cur] + 1;
      var ns = [
        x > 0    ? cur-1  : -1,
        x < LW-1 ? cur+1  : -1,
        y > 0    ? cur-LW : -1,
        y < LH-1 ? cur+LW : -1
      ];
      for (var j = 0; j < 4; j++) {
        if (ns[j] >= 0 && dist[ns[j]] > nd) {
          dist[ns[j]] = nd;
          queue.push(ns[j]);
        }
      }
    }

    distField = dist;
  }

  function draw() {
    if (!svgReady)  { raf = requestAnimationFrame(draw); return; }
    if (!distField) { buildDF(); }

    var img = ctx.createImageData(LW, LH);
    var d   = img.data;

    for (var i = 0; i < LW * LH; i++) {
      var r = distField[i];

      var v = Math.sin(r * 0.35 - t * 0.012)
            + Math.sin(r * 1.40 - t * 0.015) * 0.35
            + Math.sin(r * 0.32 + t * 0.008) * 0.40;
      var norm = Math.max(0, Math.min(1, (v + 1.95) / 3.9));

      // 거의 흰색: lightness 0.87~0.97, saturation 매우 낮음
      var hue = (norm * 200 + t * 0.22) % 360;
      var sat = 0.05 + norm * 0.08;
      var lig = 0.87 + norm * 0.10;

      var rgb  = hsl(hue/360, sat, lig);
      var base = i * 4;
      d[base]   = rgb[0];
      d[base+1] = rgb[1];
      d[base+2] = rgb[2];
      d[base+3] = 255;
    }

    ctx.putImageData(img, 0, 0);
    t  += 1;
    raf = requestAnimationFrame(draw);
  }

  function syncSize() {
    W  = window.innerWidth;
    H  = window.innerHeight;
    LW = Math.max(1, Math.round(W / SCALE));
    LH = Math.max(1, Math.round(H / SCALE));
    canvas.width  = LW;
    canvas.height = LH;
    canvas.style.width  = W + 'px';
    canvas.style.height = H + 'px';
    if (svgReady) distField = null;
  }

  function init() {
    svgImg = new Image();
    svgImg.crossOrigin = 'anonymous';
    svgImg.onload = function () { svgReady = true; };
    svgImg.src = window.SUONO_SYMBOL_URL || '/assets/suono_symbol2.svg';

    el = document.createElement('div');
    el.id = 'suono-bg-animation';

    canvas = document.createElement('canvas');
    ctx    = canvas.getContext('2d');
    el.appendChild(canvas);
    document.body.appendChild(el);

    syncSize();
    draw();

    window.addEventListener('resize', function () {
      syncSize();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
